import { FC, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { detectMob, isIphoneUserAgent, replaceUrl } from 'utils';
import { appLinks } from 'constant';
import GetTheAppPopup from '../getTheApp/getTheAppPopup/GetTheAppPopup';
import { AnalyticsEvents } from 'services/AnalyticsEvents';

const AppSwitch: FC = () => {
  const isMobile = detectMob();

  const [searchParams] = useSearchParams();

  useEffect(() => {
    const source = searchParams.get('source');

    const mailId = searchParams.get('mail_id');

    if (source) {
      AnalyticsEvents.onOpenByMail(source, mailId);
    }
    setTimeout(() => {
      if (isMobile) {
        let url = appLinks.google;
        if (isIphoneUserAgent()) {
          url = appLinks.iphone;
        }
        replaceUrl(url);
      }
    }, 0);
  }, []);

  if (isMobile) {
    return null;
  }

  return <GetTheAppPopup />;
};

export default AppSwitch;
